export enum AuthenticationStatus {
    Success,
    Failure
}
